module.exports = __webpack_public_path__ + "static/media/item-4.fdf5de3d.jpeg";